import React from "react";
import { Icon } from "@iconify/react";

import { SearchInput } from "../search-input";
import { LanguageSwitcher } from "../../language/LanguageSwitcher";

/**
 * Header del menú de búsqueda avanzada.
 *
 * @param {object} props
 * @param {object} props.textos - Textos de interfaz.
 * @param {boolean} props.isMobile - Indica si se muestra la versión mobile.
 * @param {Function} props.onBack - Función para volver a la vista anterior.
 * @returns {JSX.Element}
 */
export const AdvancedSearchHeader = ({
    textos,
    isMobile = false,
    onBack,
}) => {
    return (
        <header className="d-lg-flex search-header py-4">
            {/* Búsqueda */}
            <div className="col-12 col-lg-8">
                <SearchInput />
            </div>

            {/* Idioma */}
            <div className="col-lg-4 d-lg-flex align-items-center mt-4 mt-lg-0">
                <h2 className="section-title mb-3 mb-lg-0">
                    {textos?.header?.idioma || "Idioma"}
                </h2>
                <div className="w-100 ml-lg-4">
                    <LanguageSwitcher />
                </div>
            </div>
        </header>
    );
};